import {Api} from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";

const target = "/deposits";
const targetCredits = "/credits";

export class DepositsService {

    public static getAllDeposits(): Promise<Array<any>> {
        return Api.get(apiUrl(target+"/date"));
    }

    public static getAllDepositsByOrganization(id:number): Promise<Array<any>>{
        return Api.get(apiUrl(target+"/organization/"+id));
    }

    public static createDeposits (depositInfo:object) {
        return Api.post(apiUrl(target+"/create"), depositInfo);
    }

    public static editOrganization ( payload :any) {
        return Api.patch(apiUrl(target+"/"+payload.id), payload);
    }

    public static getMonthly (id:number | null) : Promise<Array<any>> {
        return Api.get(apiUrl(target+"/organization/"+id+"/monthly/"));
    }

    public static getDepositsByDate (id:number | null, date: string) : Promise<Array<any>> {
        return Api.get(apiUrl(target+"/organization/"+id+"/date/"+date));
    }

    public static findDepositsByUser (id:number) : Promise<Array<any>> {
        return Api.get(apiUrl(target+"/"+id));
    }

    public static getDepositsByUser (id:number) : Promise<Array<any>> {
        return Api.get(apiUrl(target+"/user/"+id));
    }

    public static getLatest (pagina:number) {
        return Api.get(apiUrl(`${target}/latest?pagina=${pagina}`)); 
    }

    public static getCreditsByUserId (id:number) {
        return Api.get(apiUrl(`${targetCredits}/${id}/list`));
    }

    // Creditos pendentes do proprio cliente logado (id vem do token).
    public static getMyPendingCredits () : Promise<Array<any>> {
        return Api.get(apiUrl(`${targetCredits}/me/pending`));
    }

    public static updateCreditStatus (creditId:number, status:string) {
        return Api.patch(apiUrl(`${targetCredits}/${creditId}`), { status });
    }

    public static getCreditsByOrganization (orgId:number, filters: { userId: number | null, status: string | null}) : Promise<Array<any>> {

        let targetUrl = `${targetCredits}/organization/${orgId}`;
        if ( filters.userId || filters.status ) {
            if (filters.userId && !filters.status) targetUrl += '?userId='+filters.userId;
            if (filters.userId && filters.status) targetUrl += '?userId='+filters.userId+"&status="+filters.status;
            if (!filters.userId && filters.status) targetUrl += "?status="+filters.status;
        } 
        return Api.get(apiUrl(targetUrl));
    }

    
}
